export const MODIFY_PROBABILITY = 'MODIFY_PROBABILITY';
export const FETCH_PROBABILITY_TYPE = 'FETCH_PROBABILITY_TYPE';
export const LIST_PROBABILITY_TYPE = 'LIST_PROBABILITY_TYPE';
export const CLEAR_PROBABILITY = 'CLEAR_PROBABILITY';
export const FETCH_PROBABILITY = 'FETCH_PROBABILITY';
export const LIST_PROBABILITY = 'LIST_PROBABILITY';


export const MODIFY_PROBABILITY_BY_DRAW = 'MODIFY_PROBABILITY_BY_DRAW';
export const CLEAR_PROBABILITY_BY_DRAW = 'CLEAR_PROBABILITY_BY_DRAW';
export const FETCH_PROBABILITY_BY_DRAW = 'FETCH_PROBABILITY_BY_DRAW';
export const LIST_PROBABILITY_BY_DRAW = 'LIST_PROBABILITY_BY_DRAW';

export const MODIFY_MANAGE_PROBABILITY_TYPE = 'MODIFY_MANAGE_PROBABILITY_TYPE';
export const FETCH_MANAGE_PROBABILITY_TYPE = 'FETCH_MANAGE_PROBABILITY_TYPE';
export const LIST_MANAGE_PROBABILITY_TYPE = 'LIST_MANAGE_PROBABILITY_TYPE';